<script>
  /** Consumes the {total,page,limit,pages,has_next,has_prev} envelope the API returns. */
  let { pagination = null, onPage = () => {} } = $props();

  const pages = $derived(pagination?.pages ?? 0);
  const page = $derived(pagination?.page ?? 1);

  const windowed = $derived.by(() => {
    if (pages <= 7) return Array.from({ length: pages }, (_, i) => i + 1);
    const out = [1];
    const from = Math.max(2, page - 1);
    const to = Math.min(pages - 1, page + 1);
    if (from > 2) out.push('…');
    for (let i = from; i <= to; i += 1) out.push(i);
    if (to < pages - 1) out.push('…');
    out.push(pages);
    return out;
  });
</script>

{#if pagination && pages > 1}
  <nav class="mt-4 flex items-center justify-between gap-4" aria-label="Pagination">
    <p class="text-xs p-muted">
      Page {page} of {pages} · {pagination.total} total
    </p>
    <div class="flex items-center gap-1">
      <button type="button" class="p-btn p-btn-quiet px-2 py-1"
              disabled={!pagination.has_prev} onclick={() => onPage(page - 1)}>Previous</button>
      {#each windowed as p}
        {#if p === '…'}
          <span class="px-2 p-faint">…</span>
        {:else}
          <button type="button" class="p-btn px-3 py-1"
                  class:p-btn-primary={p === page} class:p-btn-quiet={p !== page}
                  aria-current={p === page ? 'page' : undefined}
                  onclick={() => onPage(p)}>{p}</button>
        {/if}
      {/each}
      <button type="button" class="p-btn p-btn-quiet px-2 py-1"
              disabled={!pagination.has_next} onclick={() => onPage(page + 1)}>Next</button>
    </div>
  </nav>
{/if}
